(function(){
    'use strict';

    angular
        .module('completeAir')
        .factory('balanceUserService',balanceUserService);

    balanceUserService.$inject = ['$http', 'CONFIG','messageService'];

    function balanceUserService($http, CONFIG, messageService){

        var urlBase = CONFIG.API_URL + '/' + CONFIG.API_REPORT + '/' + CONFIG.API + '/report-balance-user';

        var service = {
            getReportBalanceUser: getReportBalanceUser,
            getReportBalanceUserPdf: getReportBalanceUserPdf,
            getReportBalanceUserByUser: getReportBalanceUserByUser
        };

        return service;

        function getReportBalanceUser(type, toDate, detail){
            return $http.get(urlBase + '/user' + '?' + type + 'toDate=' + toDate + '&detail=' + detail)
                .then(function(response){
                    return response;
                }, function(){
                    messageService.findError('');
                });
        }

        function getReportBalanceUserPdf(type, toDate, detail){
            return $http.get(urlBase + '/user/pdf' + '?' + type + 'toDate=' + toDate + '&detail=' + detail, {responseType:'arraybuffer'})
                .then(function(response){
                    return response;
                }, function(){
                    messageService.findError('');
                });
        }

        function getReportBalanceUserByUser(userLogin, type, toDate, detail){
            return $http.get(urlBase + '/byUser?' + type + '&userLogin=' + userLogin + '&toDate=' + toDate + '&detail=' + detail)
                .then(function(response){
                    return response;
                }, function(){
                    messageService.findError('');
                });
        }
    }
})();
